function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(";").shift();
    }
    return null;
}

function getCsrfToken() {
    return $("[name=csrfmiddlewaretoken]").val() || getCookie("csrftoken");
}

export default $(document).ready(e => {

    const $radioButtons = $('input[type=radio][name=objart]');
    $("#loading").hide();

    $radioButtons.change(e => {
        e.preventDefault();
        var container = $("#form");
        var selectedValue = e.target.value;
        const csrfToken = getCsrfToken();

        $.ajax({
            url: "/bewertungsform",
            type: "POST",
            data: {
                "o": selectedValue,
                csrfmiddlewaretoken: csrfToken,
            },
            headers: csrfToken ? {"X-CSRFToken": csrfToken} : {},
            beforeSend: function () {
                container.html('');
                container.hide().removeClass("animate__fadeIn");
                $("#loading").show();
            },
            complete: function () {
                $("#loading").hide();
            },
            success: (response_data) => {
                container.hide();
                container.html(response_data);
                $("#id_objektart").attr("readonly", true);
                container.addClass("animate__fadeIn").show();
            },
            error: response => {
                console.log("failure");
            }
        });
    });
})
